// TODO(Hive 5.0): replace with equivalent Hive theme token when available.
export const ORDER_WARNING_COLOR = '#e7ba4f';
